import { viVN_SupplierInformation } from './information';
import { viVN_SupplierManagement } from './management';

export const viVN_Supplier = {
  ...viVN_SupplierManagement,
  ...viVN_SupplierInformation
};
